import {gsap} from "gsap";


let tween_banner;

/**
 * Initialise la bannière
 */
const init_cookie_law = () => {

    let cookieValue;
    try {
        cookieValue = document.cookie
            .split('; ')
            .find(row => row.startsWith('cookie_law'))
            .split('=')[1];

        console.log("valeur de cookie_law : " + cookieValue);
    }catch (error) {
        console.log("pas de valeur de cookie_law");
        cookieValue = null;
    }

    if (cookieValue == null){
        $("#close_cookie").on('click', close_cookie_banner_handler);
        tween_banner= gsap.to('#cookie-law', {autoAlpha:1, y:0, ease:"power1.out", delay:5});
    }else{
        $("#cookie-law").remove();
    }

}


/**
 * Close du cookie,
 * Fais un appel aajx pour placer un cookie comme quoi le bandeau n'est plus à afficher
 */
const close_cookie_banner_handler = (e) => {
    e.preventDefault();

    $("#close_cookie").off('click', close_cookie_banner_handler);

    // Place a cookie with ajax request
    store_cookie_ajax_request()
    // Close banner
    tween_banner.reverse();
}

/**
 * requete ajax plaçant un cookie
 */

const store_cookie_ajax_request = () => {
    const request_data = {
        'action' : ajax_data.cookie_store_action,
        'nounce' : ajax_data.ajax_nounce
    }
    $.ajax({
        url: ajax_data.ajax_url,
        method:'POST',
        data: request_data,
    })
}

export default init_cookie_law;
